import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { Filter } from "./types";

export const usePublicationsFilters = () => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<Filter[]>>({
    queryKey: ["publicationsFilters"],
    queryFn: async () =>
      dispatch(
        apiThatThrows.getTiVoPublicationsFilters.action({
          cache: true,
        })
      ),
  });
};
